/**
 * PLAT-11445 (audio-first): which source a clip-preview player should play.
 *
 * While the pipeline is still producing renditions, a produced clip's `src`
 * comes from the story's mp4 chain, which bottoms out at the raw original —
 * the multi-GB upload the editor deliberately never streams (PLAT-11224). If
 * this session still holds the uploaded file, play that instead. Mux-hosted
 * clips and every post-rendition path are untouched.
 */
export interface ClipPlayerSourceInput {
  clipSrc: string | undefined;
  muxPlaybackId: string | undefined;
  renditionPending: boolean;
  localPreviewUrl: string | null | undefined;
  /** Set once the local blob errored under the player; falls back to `clipSrc`. */
  localPreviewFailed: boolean;
}

export interface ClipPlayerSource {
  src: string | undefined;
  usesLocalPreview: boolean;
}

export function resolveClipPlayerSource({
  clipSrc,
  muxPlaybackId,
  renditionPending,
  localPreviewUrl,
  localPreviewFailed,
}: ClipPlayerSourceInput): ClipPlayerSource {
  if (
    !muxPlaybackId &&
    renditionPending &&
    localPreviewUrl &&
    !localPreviewFailed
  ) {
    return { src: localPreviewUrl, usesLocalPreview: true };
  }
  return { src: clipSrc, usesLocalPreview: false };
}
